import { base44 } from '@/api/base44Client';

// Fetch a generated PDF and save it to the user's device (rather than opening
// the in-browser PDF viewer).
async function downloadPdf(url, filename) {
  const res = await fetch(url);
  const blob = await res.blob();
  const objectUrl = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = objectUrl;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  a.remove();
  URL.revokeObjectURL(objectUrl);
}

// Single-order picking slip. Admins can print any order; a signed-in customer
// only their own — the backend verifies ownership.
export async function downloadPickingSlip(orderId) {
  const res = await base44.functions.invoke('generateRetailPickingSlip', { order_id: orderId });
  if (!res?.data?.success || !res.data.pdf_url) {
    throw new Error(res?.data?.error || 'Could not generate picking slip');
  }
  await downloadPdf(res.data.pdf_url, res.data.filename || 'picking-slip.pdf');
}

// Batch picking list across the selected orders (admin only).
export async function downloadPickingList(orderIds) {
  const res = await base44.functions.invoke('generateRetailPickingList', { order_ids: orderIds });
  if (!res?.data?.success || !res.data.pdf_url) {
    throw new Error(res?.data?.error || 'Could not generate picking list');
  }
  await downloadPdf(res.data.pdf_url, res.data.filename || 'picking-list.pdf');
  return res.data;
}